/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-template */
import A11yDialog from 'a11y-dialog';

document.addEventListener("DOMContentLoaded", function () {

	// Function to get query parameters
	function getQueryParam(param) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(param);
	}

	let retailerIDCookieName = 'retailerID';

	// Check for age gate element early to get frequency setting
	let cpAgeGate = document.getElementById("age-gate");
	let frequency = 'once'; // default
	if (cpAgeGate) {
		// frequency defaults to "once" but can be set to "every" in customizer age gate settings
		frequency = cpAgeGate.dataset.ageGateFrequency || 'once';
	}

	// Check for URL parameters
	const bypassAgeGate = getQueryParam('age_verified');
	const retailerIDParam = getQueryParam('retailer');

	// If bypass is enabled, set the storage and reload the page
	if (bypassAgeGate === "true") {
		// Use sessionStorage when frequency is "every", otherwise use cookie
		if (frequency === "every") {
			cpAgeGateSetSessionStorage('cp_lifted_age_gate_passed', 'yes');
		} else {
			cpAgeGateSetCookie('cp_lifted_age_gate_passed', 'yes', 30);
		}

		if (retailerIDParam) {
			cpAgeGateSetCookie(retailerIDCookieName, retailerIDParam, 30);
			cpAgeGateSetCookie('menu_type', 'RECREATIONAL', 30);
			localStorage.setItem('cp_dutchie_pricing_type', 'RECREATIONAL');
			localStorage.setItem('cp_retailer_menu_type', 'RECREATIONAL');

			// get retailer name from locatoin selector button
			const button = document.querySelector('.age-gate button[data-retailer-id="' + retailerIDParam + '"][data-retailer-menu-type="RECREATIONAL"]');
			if (button) {
				localStorage.setItem('cp_retailer_name', button.dataset.retailerName);
			}
		}

		const url = window.location.origin + window.location.pathname;
		window.history.replaceState(null, null, url);
		location.reload(); // Reload the page to apply changes
		return;
	}

	// exit if age gate element does not exist
	if (!cpAgeGate) {
		return false;
	}

	let cpAgeGateDialog = false;

	var cpAgeGateCookieName = 'cp_lifted_age_gate_passed';
	var cpAgeGateCookieExpDays = 30;

	// function for setting cookies
	function cpAgeGateSetCookie(name, value, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
	}

	// function for getting cookies
	function cpAgeGateGetCookie(cookieName) {
		let name = cookieName + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	// function for deleting cookies
	function cpAgeGateDeleteCookie(name) {
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	}

	// function for getting sessionStorage
	function cpAgeGateGetSessionStorage(key) {
		try {
			return sessionStorage.getItem(key) || "";
		} catch (e) {
			return "";
		}
	}

	// function for setting sessionStorage
	function cpAgeGateSetSessionStorage(key, value) {
		try {
			sessionStorage.setItem(key, value);
		} catch (e) {
			// Handle storage quota exceeded or other errors
			console.error('Failed to set sessionStorage:', e);
		}
	}

	// function for deleting sessionStorage
	function cpAgeGateDeleteSessionStorage(key) {
		try {
			sessionStorage.removeItem(key);
		} catch (e) {
			console.error('Failed to delete sessionStorage:', e);
		}
	}

	// if age gate is not passed run the init
	// Use sessionStorage when frequency is "every", otherwise use cookie
	var cpAgeGatePassed;
	if (frequency === "every") {
		cpAgeGatePassed = cpAgeGateGetSessionStorage(cpAgeGateCookieName);
	} else {
		cpAgeGatePassed = cpAgeGateGetCookie(cpAgeGateCookieName);
	}

	if (!cpAgeGatePassed || cpAgeGatePassed == 'no') {
		cpAgeGateInit();
	} else {
		// Check if age gate step 2 exists (location selector is shown)
		// Step 2 is only added by the plugin when location selector is enabled and should be shown
		// On single-location sites, step 2 may not exist even if plugin is active
		const step2 = document.getElementById('age-gate-step-2');
		
		// Only validate retailer if step 2 exists (location selector is shown and retailer selection is required)
		// If step 2 doesn't exist, skip validation - this handles:
		// - Plugin inactive (no step 2, no validation needed)
		// - Single-location sites (no step 2, no validation needed - default retailer will be set)
		// - Pages where step 2 is hidden (blog, policy pages - no validation needed)
		if (step2) {
			// Validate retailerID cookie exists and is valid
			let retailerCookie = cpAgeGateGetCookie(retailerIDCookieName);
			let isValidRetailer = false;

			if (retailerCookie) {
				// Check if retailerID matches any available location selector button
				// Search within the age gate element to find buttons even if modal is hidden
				const locationButtons = cpAgeGate.querySelectorAll('.location-selector-card-button[data-retailer-id]');
				locationButtons.forEach(button => {
					if (button.dataset.retailerId == retailerCookie) {
						isValidRetailer = true;
					}
				});
			}

			// If retailerID is missing or invalid, force age gate
			if (!retailerCookie || !isValidRetailer) {
				// Clear age gate storage to force re-entry
				if (frequency === "every") {
					cpAgeGateDeleteSessionStorage(cpAgeGateCookieName);
				} else {
					cpAgeGateDeleteCookie(cpAgeGateCookieName);
				}
				cpAgeGateInit();
			}
		}
		// If step 2 doesn't exist, skip retailer validation and respect the age gate cookie
		// This allows the age gate to work correctly on single-location sites and when plugin is inactive
	}

	const step1 = document.getElementById('age-gate-step-1');
	const step2 = document.getElementById('age-gate-step-2');

	function cpAgeGateInit() {

		// show the age gate
		cpAgeGateDialog = new A11yDialog(cpAgeGate);
		cpAgeGateDialog
			.on('show', () => (document.documentElement.style.overflowY = 'hidden'))
			.on('hide', () => (document.documentElement.style.overflowY = ''));
		cpAgeGateDialog.show();

		// disable body scrolling
		document.body.style.overflow = 'hidden';

		// Yes button click event
		document.getElementById('age-gate-yes').addEventListener("click", function () {

			// check for Step 2
			if (step2) {
				step1.style.display = 'none'; // hide step 1
				step2.style.display = 'block'; // show step 2

				const event = new CustomEvent('ageGateStep2');
				document.dispatchEvent(event);
			} else {

				cpAgeGateSetCookie(retailerIDCookieName, cpAgeGate.dataset.defaultRetailerId, 30);
				cpAgeGateSetCookie('menu_type', cpAgeGate.dataset.defaultRetailerMenuType, 30);

				localStorage.setItem('cp_dutchie_pricing_type', cpAgeGate.dataset.defaultRetailerMenuType);
				localStorage.setItem('cp_retailer_menu_type', cpAgeGate.dataset.defaultRetailerMenuType);
				localStorage.setItem('cp_retailer_name', cpAgeGate.dataset.defaultRetailerName);

				cpUpdateLocationSelector();

				const event = new CustomEvent('retailerUpdate', {
					detail: {
						name: cpAgeGate.dataset.defaultRetailerName,
						id: cpAgeGate.dataset.defaultRetailerId,
						orderType: 'PICKUP',
						pricingType: cpAgeGate.dataset.defaultRetailerMenuType,
					},
				});
				document.dispatchEvent(event);

				cpCloseAgeGate();
			}
		});

		// No button click event
		document.getElementById('age-gate-no').addEventListener("click", function () {

			// set age gate cookie
			cpAgeGateSetCookie(cpAgeGateCookieName, 'no', 30);

			// show warning message
			document.getElementById('cp-age-gate-warning').classList.add("is-visible");
		});

		// location selector group toggle click
		const locationGroupToggles = cpAgeGate.querySelectorAll('.location-selector-groups button');
		const groupLists = cpAgeGate.querySelectorAll('.location-group-list');
		const locationSelectorGroups = cpAgeGate.querySelector('.location-selector-groups');
		locationGroupToggles.forEach(function (toggle) {

			let groupID = toggle.dataset.locationSelectorGroupToggle;

			toggle.addEventListener("click", function () {

				let groupToDisplay = cpAgeGate.querySelector('[data-location-selector-group="' + groupID + '"]');

				// hide group selectors
				locationSelectorGroups.style.display = 'none';

				// hide all groupLists
				groupLists.forEach(function (groupList) {
					groupList.style.display = 'none';
				});

				// show relevant groupList
				groupToDisplay.style.display = 'block';
			});
		});

		// location selector group back button click
		const locationGroupBackButtons = cpAgeGate.querySelectorAll('.location-group-list-back');
		locationGroupBackButtons.forEach(function (button) {
			button.addEventListener("click", function () {
				locationSelectorGroups.style.display = 'block';
				groupLists.forEach(function (groupList) {
					groupList.style.display = 'none';
				});
			});
		});
	}

	// location selector button clicks
	const locationSelectorButtons = document.querySelectorAll('.location-selector-card-button');
	locationSelectorButtons.forEach(function (button) {

		button.addEventListener("click", async function (e) {
			let retailerID = button.dataset.retailerId;
			let retailerMenuType = button.dataset.retailerMenuType;
			let retailerName = button.dataset.retailerName;
			let orderType = button.dataset.orderType;
			let currentMenuType = localStorage.getItem('cp_retailer_menu_type');
			let retailerURL = button.getAttribute('data-retailer-menu-url');
			let redirectURL = retailerURL || button.getAttribute('data-retailer-cpt-url');

			let shouldRedirectToRetailerURL = false;

			// Not viewing age gate -- and switching locations. show modal to users about their Shopping Cart
			if (!cpAgeGateDialog && typeof dutchie != 'undefined') {
				if (retailerID !== cpAgeGateGetCookie(retailerIDCookieName) || retailerMenuType !== currentMenuType) {
					const selector = document.querySelector('#retailer-modal');

					if (selector) {
						const cpRetailerModal = new A11yDialog(selector);
						cpRetailerModal.show();
						const locationNames = document.querySelectorAll('.retailer-modal-location-name');
						locationNames.forEach(element => {
							element.innerHTML = button.dataset.retailerName;
						});

						let chosenRetailer = dutchie.retailers.find(retailer => retailer.id === retailerID)

						// Create buttons for each menu type
						const buttonsContainer = selector.querySelector('.retailer-modal-buttons-menu-choices');
						// Empty out target
						buttonsContainer.innerHTML = '';

						const newButton = document.createElement('button');
						newButton.className = 'btn btn-primary btn-switch-retailer';
						newButton.dataset.retailerId = chosenRetailer.id;
						newButton.dataset.retailerName = chosenRetailer.name;
						newButton.dataset.menuType = retailerMenuType;
						newButton.textContent = `Continue Shopping`;
						buttonsContainer.appendChild(newButton);

						const confirmPromise = new Promise((resolve) => {
							const switchButtons = selector.querySelectorAll('.btn-switch-retailer');
							switchButtons.forEach(element => {
								element.addEventListener('click', () => {
									resolve();
									cpRetailerModal.hide();
								});
							});
						});

						const closeBtn = selector.querySelector('.retailer-modal-close')
						closeBtn.addEventListener('click', () => {
							// User clicked cancel, close the modal without proceeding.
							cpRetailerModal.hide();
						});

						// Wait for the user to confirm
						await confirmPromise;
					}
				}
			}

			// lifted base specific code
			let confirmLocationChange = button.dataset.retailerConfirmLocationChange;
			if (confirmLocationChange) {

				console.log("inside promiose");

				const locationChangeDialog = document.querySelector('#location-change-dialog');

				if (locationChangeDialog) {
					const locationChangeModal = new A11yDialog(locationChangeDialog);
					locationChangeModal.show();
					const locationNames = document.querySelectorAll('.location-change-modal-description');
					locationNames.forEach(element => {
						element.textContent = 'You are about to change your shopping location to ' + retailerName;
					});

					const retailerChangePromise = new Promise((resolve) => {
						const switchButton = document.querySelector('#switch-location-button');
						switchButton.addEventListener('click', () => {
							resolve();
							locationChangeModal.hide();
							shouldRedirectToRetailerURL = true;
						});
					});

					const closeBtn = document.querySelector('#go-back-button')
					closeBtn.addEventListener('click', () => {
						// User clicked cancel, close the modal without proceeding.
						locationChangeModal.hide();
					});

					// Wait for the user to confirm
					await retailerChangePromise;
				}
			}

			console.log("bypass promise");

			cpAgeGateSetCookie('menu_type', retailerMenuType, 30);
			cpAgeGateSetCookie(retailerIDCookieName, retailerID, 30);
			localStorage.setItem('cp_dutchie_pricing_type', retailerMenuType);
			localStorage.setItem('cp_retailer_menu_type', retailerMenuType);
			localStorage.setItem('cp_retailer_name', retailerName);

			// Load RevenueKit scripts for selected location
			const formId = button.getAttribute('data-revenuekit-form-id');
			if (formId && typeof window.injectRevenueKitScripts === 'function') {
				window.injectRevenueKitScripts(formId);
			}

			cpUpdateLocationSelector();

			if (cpAgeGateDialog) {
				cpCloseAgeGate();
			}

			// When on age gate, only redirect for View Store (CPT URL); Shop Rec/Med should just set location and close gate.
			// When not on age gate, redirect if user confirmed location change (shouldRedirectToRetailerURL).
			const isViewStoreButton = button.hasAttribute('data-retailer-cpt-url') && !button.getAttribute('data-retailer-menu-url');
			if (redirectURL && (shouldRedirectToRetailerURL || (cpAgeGateDialog && isViewStoreButton))) {
				window.location.href = redirectURL;
				return;
			}

			const event = new CustomEvent('retailerUpdate', {
				detail: {
					name: retailerName,
					id: retailerID,
					orderType: orderType ? orderType : 'PICKUP',
					pricingType: retailerMenuType,
				},
			});
			document.dispatchEvent(event);

			if (shouldRedirectToRetailerURL && redirectURL) {
				window.location.href = redirectURL;
			}

			if (!cpAgeGateDialog) {
				// Not viewing age gate
				const currentPath = window.location.pathname;
				const pathsToCheck = ['/shop/', '/specials/', '/product/'];
				// If you are not on the shop, category page, blog post, or Product Detail page -> Send user to the shop page

				if (pathsToCheck.some(path => currentPath.includes(path))) {
					return;
				}

				if (typeof dutchie != 'undefined' && dutchie.is_single_post) {
					return;
				}

				if (redirectURL) {
					window.location.href = redirectURL;
				} else if (typeof dutchie != 'undefined' && dutchie.shop_page_url) {
					window.location.href = dutchie.shop_page_url;
				}
			}
		});
	});

	let locationSelectors = document.querySelectorAll('.location-selector');
	locationSelectors.forEach(function (selector) {
		let dialog = new A11yDialog(selector);
		let buttons = selector.querySelectorAll('.location-selector-card-button');
		buttons.forEach(function (button) {
			button.addEventListener("click", function () {
				dialog.hide();
			});
		});
	});

	function cpCloseAgeGate() {
		const retailerModaleEl = document.querySelector('#retailer-modal');
		if (retailerModaleEl) {
			let cpRetailerModal = new A11yDialog(retailerModaleEl);
			cpRetailerModal.hide();
		}

		// set age gate storage, do not set for policy pages
		// Use sessionStorage when frequency is "every", otherwise use cookie
		if (!document.body.classList.contains('page-template-page-template-policy')) {
			if (frequency === "every") {
				cpAgeGateSetSessionStorage(cpAgeGateCookieName, 'yes');
			} else {
				cpAgeGateSetCookie(cpAgeGateCookieName, 'yes', cpAgeGateCookieExpDays);
			}
		}

		// hide age gate
		cpAgeGateDialog.hide();

		// enable body scrolling
		document.body.style.overflow = 'visible';
	}

});

export function cpUpdateLocationSelector() {

	let retailerMenuType = localStorage.getItem('cp_retailer_menu_type');
	let retailerName = localStorage.getItem('cp_retailer_name');

	if (retailerName) {
		let names = document.querySelectorAll('.cp-location-name');
		names.forEach(function (name) {
			name.innerHTML = retailerName;
		});
	}

	let rec_abbreviation = 'Rec';
	let med_abbreviation = 'Med';

	let cpAgeGate = document.getElementById("age-gate");
	if (cpAgeGate) {

		let rec_abbreviation_override = cpAgeGate.dataset.locationSelectorRecAbbreviation;
		if (rec_abbreviation_override) {
			rec_abbreviation = rec_abbreviation_override;
		}

		let med_abbreviation_override = cpAgeGate.dataset.locationSelectorMedAbbreviation;
		if (med_abbreviation_override) {
			med_abbreviation = med_abbreviation_override;
		}
	}

	if (retailerMenuType) {

		if (retailerMenuType == 'RECREATIONAL') {
			retailerMenuType = rec_abbreviation;
		}

		if (retailerMenuType == 'MEDICAL') {
			retailerMenuType = med_abbreviation;
		}

		let menuTypes = document.querySelectorAll('.cp-location-menu-type');
		menuTypes.forEach(function (menuType) {
			menuType.innerHTML = retailerMenuType;
		});
	}

}
document.addEventListener('DOMContentLoaded', function () {
	cpUpdateLocationSelector();
});
